module.exports = "1. 这是说明信息\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/specTracker/specTracker-14.txt
// module id = SZRf
// module chunks = 2